const padTime = (value: number) => value.toString().padStart(2, '0')

const toMinutesAndSeconds = (seconds: number) => {
    const safe = Number.isFinite(seconds) && seconds > 0 ? seconds : 0
    const minutes = Math.floor(safe / 60)
    const remain = Math.floor(safe % 60)
    return { minutes, remain }
}

export const formatBarTime = (seconds: number, error?: boolean) => {
    if (error) {
        return '--'
    }
    const { minutes, remain } = toMinutesAndSeconds(seconds)
    return `${minutes}:${padTime(remain)}`
}

export const formatBarDuration = (currentTime: number, duration: number, error?: boolean) => {
    if (error) {
        return '--/--'
    }
    return `${formatBarTime(currentTime)}/${formatBarTime(duration)}`
}

export const formatVoiceDuration = (seconds: number, error?: boolean) => {
    if (error) {
        return '--'
    }
    const { minutes, remain } = toMinutesAndSeconds(seconds)
    return `${minutes}'${padTime(remain)}"`
}
